// apis/feedback/get-unread-counts.ts
import { useQuery } from "@tanstack/react-query";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetUnreadCounts = () =>
    useQuery({
        queryKey: ["get_unread_counts"],
        queryFn: async () => {
            const [userCount, driverCount] = await Promise.all([
                apiClient.get(ENDPOINTS.FEEDBACK.UNREAD_COUNT_USER),
                apiClient.get(ENDPOINTS.FEEDBACK.UNREAD_COUNT_DRIVER),
            ]);
            return {
                user: userCount.data?.unreadCount ?? 0,
                driver: driverCount.data?.unreadCount ?? 0,
            };
        },
    });